import { Box, Stack, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive";
import { motion } from "motion/react";
import {
  classLabels,
  PitClass,
  SectionHeader,
  SectionHeaderHighlight,
} from "@src/helpers/taxonomy";

import React, { FC } from "react";
import GlassContainer from "./GlassContainer";
import MarkdownWrapper from "../Markdown/MarkdownWrapper";

interface Props {
  pitClass: PitClass;
}

const Class: FC<Props> = ({ pitClass }) => {
  return (
    <>
      <motion.div
        initial={{
          opacity: 0,
          translate: "0px -20px",
        }}
        layout
        transition={{
          delay: 0.06,
        }}
        whileInView={{
          opacity: 1,
          translate: "0px 0px",
        }}
      >
        <GlassContainer>
          <>
            <Box
              component={motion.div}
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 10,
                borderBottomRightRadius: "15px",
                borderBottomLeftRadius: "15px",
                display: "flex",
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                backgroundImage: `linear-gradient(0deg,${Colors.InfoMain}2B 10%, ${Colors.InfoMain}00 100%)`,
                pointerEvents: !open ? "all" : "none",
              }}
              initial={{
                opacity: 0,
              }}
              whileHover={{
                opacity: !open ? 1 : 0,
              }}
            >
              Read more
            </Box>

            <Stack
              sx={{
                gap: "20px",
              }}
            >
              <Stack>
                <Stack
                  sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <SectionHeaderHighlight>
                    {classLabels[pitClass.id]}
                  </SectionHeaderHighlight>
                  <SectionHeader>Class</SectionHeader>
                </Stack>

                <Stack
                  id="modal-modal-description"
                  sx={{
                    gap: "24px",
                  }}
                >
                  <MarkdownWrapper content={pitClass.description} />
                </Stack>
              </Stack>
            </Stack>
          </>
        </GlassContainer>
      </motion.div>
    </>
  );
};

export default Class;
